import React, {
  useState, useEffect,
  useRef, useContext
} from "react";
import { XLg, List } from "react-bootstrap-icons";
import {
  header, top, body,
  head, menu, opened,
  logo, cartIcon, closeIcon,
  left, right,
  tabContent, active,
  mobileHeader,
  contact, accountUser, center,
  cartCount, cartContainer, mobileLogo, trustedShop
} from "../style.mod.scss";
import MobileBody from "./body";
import GlobalContext from "services/global-context";
import CartIcon from "assets/svgs/cart-icon.svg";
import Logo from "assets/images/olavson.svg";
import Link from "components/link";
import User from "assets/images/icons/user.svg";
import UserLoggedIn from "assets/images/icons/userLoggedIn.svg";
import RebrandingNotice from "src/components/rebranding-notice";
import QuestionsMarkIcon from "src/assets/svgs/HelpMeBadge.svg";
import XIcon from "src/assets/svgs/x-icon.svg";
import trustbadge from "assets/images/trustbadge.webp";

const Header = ({ headerData, socialData, contactUrl, rebranding, disableScrollableMenu }) => {
  const globalContext = useContext(GlobalContext);
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const _mobileMenu = useRef(null);

  let cartTotalQty;

  if (typeof window === "undefined")
    cartTotalQty = 0;
  else
    cartTotalQty = localStorage.getItem("cartTotalQty") || 0;


  useEffect(() => {
    const leftScroll = sessionStorage.getItem("myOlavMobileHeaderScroll");
    if (leftScroll) _mobileMenu.current.scrollLeft = leftScroll;
  }, []);

  const onTouchEnd = () => {
    const leftScroll = _mobileMenu.current.scrollLeft;
    sessionStorage.setItem("myOlavMobileHeaderScroll", leftScroll);
  };

  const openClass = () => open ? opened : "";
  const activeTabClass = (tab) => activeTab === tab ? active : "";
  const toggleMenu = (isOpen = false) => {
    setOpen(isOpen);
    !isOpen && setActiveTab(null);
  };

  const CloseIcon = (props) => (
    <a
      className={`${closeIcon} ${openClass()}`}
      onClick={props.onClick}>
      {open ? <XLg /> : <List />}
    </a>
  );

  const isDirect = (lnk) => lnk._type === "directLink";

  const handleLogin = () => {
    globalContext?.setCurrentPanel("registration");
  };

  const [openNotice, setOpenNotice] = useState(false);

  const hideModal = () => setOpenNotice(false);

  const MobileMenu = (props) => (
    <div className={props.className} onBlur={toggleMenu} ref={_mobileMenu} onTouchEnd={onTouchEnd}>
      {
        headerData?.link?.map((tab) => (
          <Link
            key={tab._key}
            to={isDirect(tab) ? tab.url : "#"}
            className={`${activeTabClass(tab._key)}`}
            activeClassName={active}
            style={{ color: tab?.textColor && tab?.textColor?.hex }}
          >
            {tab.title}
          </Link>
        ))
      }
    </div>
  );

  function toggleMenuHeader() {
    toggleMenu(!open);
    const body = document.body;
    const isOpenHeader = body.classList.contains("no-scroll");

    if (!isOpenHeader) {
      document.documentElement.classList.add("no-scroll");
      document.body.classList.add("no-scroll");
    }
    else {
      document.documentElement.classList.remove("no-scroll");
      document.body.classList.remove("no-scroll");
    }
  }

  useEffect(() => {
    return () => {
      document.documentElement.classList.remove("no-scroll");
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <div className={`${header} ${mobileHeader}`}>
      <div className={head}>
        <div className={top}>
          <div className={left}>
            <CloseIcon onClick={toggleMenuHeader} />
          </div>
          <div className={center}>
            <Link to="/" ><img src={Logo} className={logo} alt="Olavson Logo" /></Link>
            {rebranding?.enableRebranding && <QuestionsMarkIcon onClick={() => setOpenNotice(!openNotice)} />}
          </div>
          <div className={right}>
            <img src={trustbadge} alt="Trusted Shops Logo" className={trustedShop} />
            {(!globalContext?.disableAccounts && globalContext?.currentCustomer === null) && <img src={User} onClick={handleLogin} className={accountUser} alt="user icon" />}
            {(!globalContext?.disableAccounts && globalContext?.currentCustomer !== null) && <Link to="/account/invite-friends"><img src={UserLoggedIn} className={accountUser} alt="account image" /></Link>}
            <Link to={contactUrl} className={contact}>Kontakt</Link>
            <div className={cartContainer} onClick={globalContext?.toggleCart}>
              <div className={cartIcon}><CartIcon /></div>
              {
                cartTotalQty !== null && parseInt(cartTotalQty) !== 0 && <div className={cartCount}>{cartTotalQty}</div>
              }
            </div>
          </div>
        </div>
        {!disableScrollableMenu &&
          <MobileMenu className={menu} />}
      </div>
      <div className={`${body} ${openClass()}`}>
        <div className={tabContent}>
          <div className={mobileLogo}>
            <Link to="/" ><img src={Logo} className={logo} alt="Olavson Logo" /></Link>
            <span onClick={toggleMenuHeader}>
              <XIcon />
            </span>
          </div>
          <MobileBody headerData={headerData} socialData={socialData} toggleMenuHeader={toggleMenuHeader} />
        </div>
      </div>
      {openNotice &&
        <RebrandingNotice rebranding={rebranding} openNotice={openNotice} hideModal={hideModal} />}
    </div>
  );
};

export default Header;
